import { useEffect } from "react";
import { useCurrentUser } from "./context/UserContext";
import { useInvalidateAllSiteQueries } from "./global_functions/sites/sitesQueries";
import { userEvents } from "./userEvents";

export function UserEventManager() {
  const { refreshCurrentUser } = useCurrentUser();
  const invalidateAllSitesQueries = useInvalidateAllSiteQueries();

  useEffect(() => {
    // refresh current user info and sites data when token is force refreshed
    async function refreshUserData() {
      await Promise.all([refreshCurrentUser(), invalidateAllSitesQueries()]);
    }
    userEvents.on("forceTokenRefresh", refreshUserData);

    return () => userEvents.off("forceTokenRefresh", refreshUserData);
  }, [refreshCurrentUser, invalidateAllSitesQueries]);

  return null;
}
